export const filterByAlias = (data, toCompare) => {
  if (!toCompare.length) return [];

  const aliasesSet = new Set(toCompare.map((item) => item.alias));
  return data.filter((item) => aliasesSet.has(item.alias));
};
